import React, { useContext, useEffect, lazy } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import TargetContext from "./TargetContext";
import SubscriberDetailHelpModal from "./Help";
import { Header } from "common/Header";
import useProfile from "common/hooks/useProfile";
import LazyInView from "common/LazyInView";

const SubscriberGroupDashboard = lazy(() =>
  import("./SubscriberGroupDashboard")
);
const SubscriberGroupDPI = lazy(() => import("./SubscriberGroupDPI"));
const TCPOComparison = lazy(() =>
  import("views/Status/TCPOComparison/component")
);
const ViewContainer = styled.div``;

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <div className="context-menu">
      <a
        data-loading-effect="pulse"
        data-toggle="cardloading"
        title="Help"
        onClick={() => actions.send("open-help-dashboard")}
      >
        <i className="material-icons">
          <small>help_outline</small>
        </i>
      </a>
      <a
        onClick={() => {
          actions.send("do-load-details")
          actions.send("do-load-details-dpi")
          actions.send("do-load-details-tcpo")}
        }
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">
          <small>refresh</small>
        </i>
      </a>
    </div>
  );
};

const Footer = styled.div`
  background-color: var(--Background-Block);
  margin-top: -30px;
  padding-bottom: 30px;
`;

const TCPOWrapper = styled.div`
  > div {
    padding: 0;
  }
`;

const SubscriberGroupDashboardWrapper = styled.div`
  min-height: 2000px;
`;

const SubscriberGroupDPIWrapper = styled.div`
  min-height: 830px;
`;

export const applyParams = (child, params = {}) =>
  React.isValidElement(child) ? React.cloneElement(child, params) : child;

const Panel = ({ children, ...props }) => (
  <div className="card">
    <div className="body">{children({ ...props })}</div>
  </div>
);

const container = ({
  subscriberGroup,
  returnView,
  direction,
  timePeriod,
  metric,
  ipAddress,
  type,
}) => {
  const profile = useProfile() || {};
  const settingsSubscriberGroups = {
    direction,
    timePeriod,
    metric,
    ipAddress,
    type,
  };

  useEffect(() => {
    $("html")[0].scrollTop = 0;
  }, []);

  return (
    <>
      <Header
        title={
          <>
            Subscriber Group Dashboard:&nbsp;
            <span className="case-sensitive">{subscriberGroup}</span>
          </>
        }
        backButton={returnView !== null}
        contextMenu={<ContextMenu />}
      />
      <ViewContainer className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-0">
        <TargetContext subscriberGroup={subscriberGroup}>
          <div />
          <Panel name="analytics">
            {(props) => (
              <SubscriberGroupDashboardWrapper>
                <LazyInView>
                  <SubscriberGroupDashboard
                    {...props}
                    subscriberGroup={subscriberGroup}
                    settingsSubscriberGroups={settingsSubscriberGroups}
                  />
                </LazyInView>
              </SubscriberGroupDashboardWrapper>
            )}
          </Panel>
        </TargetContext>
        {profile && profile.dpiEnabled ? (
          <SubscriberGroupDPIWrapper>
            <LazyInView>
              <SubscriberGroupDPI
                subscriberGroup={subscriberGroup}
                period={timePeriod}
              />
            </LazyInView>
          </SubscriberGroupDPIWrapper>
        ) : null}
        <TCPOWrapper>
          <LazyInView>
            <TCPOComparison
              bqnSelector={false}
              subscriberGroup={subscriberGroup}
              reloadSignal="do-load-details-tcpo"
              limitPeriods={true}
            />
          </LazyInView>
        </TCPOWrapper>
        <SubscriberDetailHelpModal />
      </ViewContainer>
    </>
  );
};

export default container;
